import React from 'react';
import { useNavigate } from 'react-router-dom';

const Blog = () => {
    const navigate = useNavigate();

    return (
        <div className="relative min-h-screen">
            {/* Static Diagonal Gradient Background */}
            <div
                className="fixed inset-0 z-0"
                style={{
                    background: 'linear-gradient(135deg, rgb(59, 130, 246) 0%, rgb(236, 72, 153) 100%)'
                }}
            />

            {/* Navbar */}
            <nav className="fixed top-0 w-full z-50">
                <div className="relative w-full h-20 py-4">
                    <div
                        className="fixed flex items-center space-x-3"
                        style={{ left: '10%', top: '1.5rem' }}
                    >
                        <button 
                            onClick={() => navigate('/')}
                            className="flex items-center gap-3 text-white hover:opacity-80 transition-opacity duration-200"
                        >
                            <img src="/logo.png" alt="mifamli logo" className="h-12 w-12" />
                            <span className="text-3xl font-bold drop-shadow-lg">mifamli</span>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="relative z-10 min-h-screen flex items-center justify-center px-4 pt-32 pb-16">
                <div className="max-w-3xl mx-auto text-center">
                    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-8">
                        Blog
                    </h1>
                    <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/30">
                        <p className="text-2xl sm:text-3xl text-white mb-6">
                            Coming Soon
                        </p>
                        <p className="text-xl text-white/90 leading-relaxed">
                            We're crafting something special for you. Good things take time, and we're committed to bringing you the best experience.
                        </p>
                        <button
                            onClick={() => navigate('/')}
                            className="mt-8 px-8 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/50 rounded-xl text-white font-semibold text-lg hover:bg-white/30 transition-all duration-200"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;

